module.exports = __webpack_public_path__ + "img/7.b6679d44.gif";